import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRocketmanTransport } from '../rocketman/RocketmanTransportContext';
import translate from '../../services/Translation/lang';
import { isSoaringGame } from '../../services/RocketmanTransport';
import { GAME_STATUS } from "../../store/features/status";

export default function RetailRoundIdSoaring() {
  const status = useSelector((state) => state.status);
  const [shouldRender, setShouldRender] = useState(false);
  const prevStatus = useRef(null);
  const rocketmanContext = useRocketmanTransport();
  const currRound = rocketmanContext.currRound;

  useEffect(() => {
    if (prevStatus.current !== null && prevStatus.current !== status) {
      setShouldRender(true);
    }
    prevStatus.current = status;
  }, [status]);

  if (!shouldRender) return null;
  
  return (
    <div className={
      "retail-round-id-soaring" +
      (isSoaringGame ? " soaring" : "") +
      (status === GAME_STATUS.IDLE ? " idle" : "")
    }>
      <span className="retail-round-id-title">{translate('round_id')}</span>
      <span>{currRound}</span>
    </div>
  );
}
